import angular from 'angular';

angular.module('cloudX').directive('validateEmail', [
  function() {
    return {
      restrict: 'A',
      require: ['?ngModel', '^?bindErrors'],
      link: function(scope, element, attributes, ctrls) {
        var ngModel = ctrls[0];
        var bindErrors = ctrls[1];
        if (!ngModel) return;
        ngModel.$validators.email = function(modelValue) {
          //Allow empty, use the required validator to block empty values
          if (typeof modelValue === 'undefined' || modelValue === null || modelValue.length === 0)
            return true;
          if (!/^[^@]+@.+\..+$/.test(modelValue)) return false; //easy regex
          // Used html email input regex:
          // https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
          return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i.test(
            modelValue,
          );
        };
        if (bindErrors) {
          bindErrors.addError('email', 9, ['email']);
          //ngModel.$viewChangeListeners.push(function () {
          //    bindErrors.refreshErrors(ngModel.$error);
          //});
          //scope.$on('$destroy', function () {
          //    bindErrors.refreshErrors();
          //});
        }
      },
    };
  },
]);
